import secureLocalStorage from "react-secure-storage";
import React from "react";
import { TextArea } from "@progress/kendo-react-inputs";
import { GridCell } from "@progress/kendo-react-grid";
import { formatNumber } from "@telerik/kendo-intl";
import { Component } from "react";
import "../../Styles/RiskDiscription.scss";


export default class RiskCauseCell extends GridCell {
  constructor(props) {
    super(props);
    this.state = {
      temp: this.props.dataItem.cause,
    };
  }

  componentDidMount = () => {
    if (this.props.dataItem.inEdit && document.getElementById("causeid")) {
      document.getElementById("causeid").focus();
    }
  };
  handleChange = (e) => {
    this.setState({ temp: e.value });
  };
  handleBlur = (e) => {
    this.props.handleCellAddValue(this.state.temp);
    this.props.onChange({
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: this.state.temp,
    });
    if (
      this.props.field &&
      this.props.field === this.props.dataItem.inEdit &&
      this.props.dataItem.riskRegisterId
    ) {
      let updateData = {
        ...this.props.dataItem,
        cause: this.state.temp,
      };
      if (this.state.temp != this.props.dataItem.cause) {
        this.props.updateDropdownValue(updateData);
      }
    }
  };
  handleChangeForAdd = (e) => {
    this.props.handleCellAddValue(e.value);
  };
  handleEditCell = () => {
    if (this.props.dataItem.riskRegisterId) {
      this.props.onEditCell(this.props.dataItem, this.props.field);
    }
  };
  render() {
    const { dataItem, field } = this.props;
    const userEmail = secureLocalStorage.getItem("userName");
    const owner = dataItem.owner;

    const dataValue =
      dataItem[field] === null || dataItem[field] == undefined
        ? ""
        : dataItem[field];
    if (this.props.field && this.props.field === this.props.dataItem.inEdit) {
      return (
        <td  className="k-grid-content-sticky-temp  inlineEditField">
          {this.props.riskAddOrEdit == true ? (
            <TextArea
              defaultValue={dataValue}
              onChange={(e) => this.handleChangeForAdd(e)}
              id="causeid"
            />
          ) : (
            <TextArea
              defaultValue={dataValue}
              onChange={(e) => this.handleChange(e)}
              onBlur={this.handleBlur}
              id="causeid"
            />
          )}
        </td>
      );
    } else {
      if (userEmail === owner) {
        return (
          <td title={dataValue} onClick={this.handleEditCell}>
            <p>{dataValue}</p>
          </td>
        );
      } else {
        return this.props.dataItem.role == "Standard User" ||
          this.props.dataItem.role == "View Only" ? (
          <td title={dataValue}>
            <p>{dataValue}</p>
          </td>
        ) : (
          <td title={dataValue} onClick={this.handleEditCell}>
            <p>{dataValue}</p>
          </td>
        );
      }
    }
  }
}
